module.exports = __webpack_public_path__ + "img/kind_0.fbddc011.jpg";